import { useOktaAuth as useVendorAuth } from "@okta/okta-react";

export const useOktaAuth = () => {
  const { oktaAuth } = useVendorAuth();

  return {
    accessToken: oktaAuth.getAccessToken(),
  };
};
